import type { PropertyListServerFilters } from '../contexts/CRMContext';

// Mirror of PropiedadesView's sessionStorage keys (see useSessionState calls
// at the top of that file). Kept here so non-React contexts (the CRM init
// effect, sidebar hover prefetch) can read the same filter shape that the
// page would build on mount.
const SS_TAB = 'propiedades:activeTab';
const SS_FILTERS = 'propiedades:advFilters';
const SS_SEARCH = 'propiedades:searchQuery';

function safeGet<T>(key: string, fallback: T): T {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

// Reads the user's persisted Propiedades filters from sessionStorage and
// returns the server-side filter shape that fetchProperties accepts.
// Returns an empty object on a fresh tab (no sessionStorage entries yet),
// which yields the same unfiltered fetch the CRM was already doing.
export function readPropertiesFiltersFromSession(): PropertyListServerFilters {
  const tab = safeGet<string>(SS_TAB, 'activas');
  const adv = safeGet<Record<string, any>>(SS_FILTERS, {});
  const search = safeGet<string>(SS_SEARCH, '');

  return {
    activeTab: tab as PropertyListServerFilters['activeTab'],
    publishStatus: adv?.publishStatus && adv.publishStatus !== 'All' ? adv.publishStatus : undefined,
    shareStatus: adv?.shareStatus && adv.shareStatus !== 'All' ? adv.shareStatus : undefined,
    operation: adv?.operation && adv.operation !== 'All' ? adv.operation : undefined,
    propertyStatus: adv?.propertyStatus && adv.propertyStatus !== 'All' ? adv.propertyStatus : undefined,
    department_id: adv?.department_id,
    city_ids: Array.isArray(adv?.city_ids) && adv.city_ids.length > 0 ? adv.city_ids : undefined,
    sector_ids: Array.isArray(adv?.sector_ids) && adv.sector_ids.length > 0 ? adv.sector_ids : undefined,
    agent_ids: Array.isArray(adv?.agent_ids) && adv.agent_ids.length > 0 ? adv.agent_ids : undefined,
    proyecto_ids: Array.isArray(adv?.proyecto_ids) && adv.proyecto_ids.length > 0 ? adv.proyecto_ids : undefined,
    search: search?.trim() ? search.trim() : undefined,
  };
}
